import React, {SetStateAction, useEffect, useMemo, useRef, useState} from 'react';
import {
    Box,
    Button, CircularProgress,
    createTheme,
    Dialog, DialogActions, DialogContent,
    DialogTitle,
    IconButton, Paper,
    Switch,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    ThemeProvider,
    Tooltip,
    Typography
} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {
    MaterialReactTable,
    MRT_Row,
    useMaterialReactTable
} from "material-react-table";
import { getDayjsLocale, getMrtLocalization } from "../../i18n/muiAdmin";
import { t } from "../../i18n/t";
import { useGetUsers} from "../../hooks/reports";
import reportsService from "../../api/reportsService";
import authService from "../../api/authService";
import information from "../../assets/information.png";
import CanvasGrid from "../CanvasGrid";
import CanvasGridDashboard from "../CanvasGridDashboard";
import axios from "axios";
import { Reports } from '../../types/types';
import {useNavigate} from "react-router";
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import config from "../../config";
import EditIcon from "@mui/icons-material/Edit";
interface KeyValuePair {
    id: number;
    key: string;
    value: string;
    userId: number;
}

interface UserPair {
    id: number;
    name: string;
}

const url = `${config.api.baseUrl}`
//const url = 'https://seemeworking.com:3066'
//const url = 'http://localhost:3000'
const ReportsComponent = () => {


//call READ hook
    const {
        data: fetchedReports = [],
        isError: isLoadingUsersError,
        isFetching: isFetchingUsers,
        isLoading: isLoadingUsers,
        refetch
    } = useGetUsers();
    const [loadingRows, setLoadingRows] = useState<Record<number, boolean>>({});
    const [loadingRowsShort, setLoadingRowsShort] = useState<Record<number, boolean>>({});
    const [loading, setLoading] = useState(false)
    const [loadingRowsXls, setLoadingRowsXls] = useState<Record<number, boolean>>({});
    const [rowFilters, setRowFilters] = useState<Record<number, boolean>>({});
    const prevRowFiltersRef = useRef();
    const navigate = useNavigate();
    useEffect(()=>{

        const prevRowFilters = prevRowFiltersRef.current;

        if (prevRowFilters) {
            // Сравниваем предыдущее и текущее значение
            // @ts-ignore
            const changedKeys = [];

            // Проверяем все ключи из предыдущего объекта
            Object.keys(prevRowFilters).forEach(key => {
                // @ts-ignore
                if (prevRowFilters[key] !== rowFilters[key]) {
                    changedKeys.push(key);
                }
            });

            // Проверяем новые ключи, которых не было в предыдущем объекте
            Object.keys(rowFilters).forEach(key => {
                if (!(key in prevRowFilters)) {
                    changedKeys.push(key);
                }
            });

            if (changedKeys.length > 0) {

                // @ts-ignore
                const report = fetchedReports.find((row) => row.id ===Number(changedKeys[0]))

            }
        }

        // Сохраняем текущее значение для следующего рендера
        // @ts-ignore
        prevRowFiltersRef.current = rowFilters;
        //handlePoints(row.original.value, row.original.pin, row.original.id)

    },[rowFilters])
    const columns = useMemo(
        () => {
            // @ts-ignore

            // @ts-ignore
            return [
                {
                    accessorKey: 'id',
                    header: 'Id',
                    enableEditing: false,
                    size: 50,
                },{
                    accessorKey: 'email',
                    header: 'email',
                    enableEditing: false,
                    size: 50,
                    // @ts-ignore
                    Cell: ({cell}) => (
                        <div>
                            {cell.getValue()}
                        </div>
                    ),

                },{
                    accessorKey: 'first_name',
                    header: 'first name',
                    enableEditing: false,
                    size: 50,
                    // @ts-ignore
                    Cell: ({cell}) => (
                        <div>
                            {cell.getValue()}
                        </div>
                    ),

                },{
                    accessorKey: 'last_name',
                    header: 'last name',
                    enableEditing: false,
                    size: 50,
                    // @ts-ignore
                    Cell: ({cell}) => (
                        <div>
                            {cell.getValue()}
                        </div>
                    ),

                },{
                    accessorKey: 'middle_name',
                    header: 'middle name',
                    enableEditing: false,
                    size: 50,
                    // @ts-ignore
                    Cell: ({cell}) => (
                        <div>
                            {cell.getValue()}
                        </div>
                    ),

                },{
                    id: 'manager',
                    accessorFn: (row: { manager?: { first_name?: string; last_name?: string; id?: number } | null; managerId?: number | null }) => {
                        if (row.manager) {
                            return [row.manager.last_name, row.manager.first_name].filter(Boolean).join(' ')
                                || `#${row.manager.id}`;
                        }
                        return row.managerId != null ? `#${row.managerId}` : '';
                    },
                    header: t('users.manager'),
                    enableEditing: false,
                    size: 80,
                },


            ];
        },
        [fetchedReports, rowFilters],
    );

    // @ts-ignore
    const [selectedUser, setSelectedUser] = useState<UserPair>(null);
    const [keyValueModalOpen, setKeyValueModalOpen] = useState(false);



    // @ts-ignore

    // @ts-ignore
    // @ts-ignore
    const table = useMaterialReactTable({
        columns,
        enableEditing: true,
        editDisplayMode: 'cell',
        localization: getMrtLocalization(),
        enableSelectAll:false,
        data:fetchedReports,
        enableColumnFilterModes: false,
        enableColumnOrdering: true,
        enableColumnPinning: true,
        enableFacetedValues: true,
        enableRowActions: true,
        enableRowSelection: false,
        initialState: {
            showColumnFilters: true,
            columnPinning: {
                right: ['mrt-row-actions'],
            },
        },
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        muiSearchTextFieldProps: {
            size: 'small',
            variant: 'outlined',
        },
        muiPaginationProps: {
            color: 'secondary',
            rowsPerPageOptions: [10, 20, 30],
            shape: 'rounded',
            variant: 'outlined',

        },
        muiBottomToolbarProps:{
            sx: {
                justifyContent: 'flex-start',
            }
        },
        enablePagination:true,

        muiTableBodyRowProps: ({ row }) => ({
            onClick: () => navigate('/dashboard/users/' + (row.original as { id: number }).id),
            sx: { cursor: 'pointer' },
        }),

        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }} onClick={(e) => e.stopPropagation()}>
                <Tooltip title={t('users.manageProps')}>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            // @ts-ignore
                            setSelectedUser(row.original);
                            setKeyValueModalOpen(true);
                        }}
                    >
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),

        renderBottomToolbarCustomActions:({table})=>(
            <Box></Box>
        ),
        state: {
            isLoading:isLoadingUsers,

        },

    });
    useEffect(()=>{
        authService.get().then((res)=>{

            setUser(res?.data)
        })

    },[])
    const [user, setUser] = useState({
        gender: undefined,
        last_name: undefined,
        id: undefined,
        first_name: undefined,
        weight: undefined,
        height: undefined,
        age: undefined,
        middle_name: undefined
    })
    const [allPoints, setAllPoints] = useState([{x:0,y:0, y1:0, isRPeaks:false}]);


     return (
        <>
           <MaterialReactTable
            table={table} />

            <Dialog
                open={keyValueModalOpen}
                onClose={() => setKeyValueModalOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {t('keyValue.userProps')}
                </DialogTitle>
                <DialogContent>
                    {selectedUser && (
                        <KeyValueManager
                            userId={selectedUser.id}
                            onClose={() => setKeyValueModalOpen(false)}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setKeyValueModalOpen(false)}>{t('common.close')}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
};



// @ts-ignore
const KeyValueManager = ({ userId, onClose }) => {
    const [keyValues, setKeyValues] = useState<KeyValuePair[]>([]);
    const [newKey, setNewKey] = useState('');
    const [newValue, setNewValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [editingItem, setEditingItem] = useState<KeyValuePair | null>(null);
    const [addingItem, setAddingItem] = useState<boolean | null>(null);
    const [isApplying, setIsApplying] = useState(false);

    useEffect(() => {
        const fetchKeyValues = async () => {
            setIsLoading(true);
            try {
                const response = await authService.getKeyValues(userId);
                //const data = await response.json();
                setKeyValues(response.data);
            } catch (error) {
                console.error('Ошибка загрузки:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchKeyValues();
    }, [userId]);

    const handleAdd = async () => {
        if (!newKey.trim()) return;

        try {
            const result = await authService.createKeyValue({
                key: newKey,
                value: newValue,
                userId
            });

            // @ts-ignore
            setKeyValues([...keyValues, result.data]);
            setNewKey('');
            setNewValue('');
        } catch (error) {
            console.error('Ошибка добавления:', error);
            // Можно добавить уведомление об ошибке
        }
    };

    const handleDelete = async (id: number) => {
        try {
            await authService.deleteKeyValue(id);
            setKeyValues(keyValues.filter(kv => kv.id !== id));
        } catch (error) {
            console.error('Ошибка удаления:', error);
        }
    };

    const handleUpdate = async (key: string, newValue: string) => {

        try {
            const result = await authService.updateKeyValue({ key, value: newValue, userId });
            // @ts-ignore
            setKeyValues(keyValues.map(kv => kv.id === result.data.id ? result.data : kv));
        } catch (error) {
            console.error('Ошибка обновления:', error);
        }
    };
    const handleApplyToAll = async () => {
        if (!window.confirm(t('keyValue.confirmApplyAll'))) return;

        try {
            setIsApplying(true);
            await authService.applyKeyValuesToAllUsers(userId);
            alert(t('keyValue.applySuccess'));
        } catch (error) {
            console.error('Ошибка:', error);
            // @ts-ignore
            alert(t('keyValue.errorPrefix', { message: (error as Error).message }));
        } finally {
            setIsApplying(false);
        }
    };
    const [recommendations, setRecommendations] = useState<string | null>(null);
    const [isGenerating, setIsGenerating] = useState(false);

    const handleGenerateRecommendations = async (key:string) => {
        setIsGenerating(true);
        try {
            const result = await authService.generateRecommendations(userId, key);

            if (result.data.success) {
                setRecommendations(result.data.recommendations);
            } else {
                alert(t('keyValue.errorPrefix', { message: result.data.error }));
            }
        } catch (error) {
            console.error('Ошибка генерации рекомендаций:', error);
            alert(t('users.genFailed'));
        } finally {
            setIsGenerating(false);
        }
    };
    // @ts-ignore
    return (
        <Box>
            {isLoading ? (
                <CircularProgress />
            ) : (
                <>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('keyValue.key')}</TableCell>
                                    <TableCell>{t('keyValue.value')}</TableCell>
                                    <TableCell>{t('keyValue.actions')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {keyValues.length > 0 ? (
                                    keyValues.map((kv) => (
                                        <TableRow key={kv.id}>
                                            <TableCell>{kv.key}</TableCell>
                                            <TableCell>
                                                <TextField
                                                    value={kv.value}
                                                    //onChange={(e) => handleUpdate(kv.key, e.target.value)}
                                                    size="small"
                                                    disabled={true}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <IconButton onClick={() => handleDelete(kv.id)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                                <Tooltip title={t('common.edit')}>
                                                    <IconButton onClick={() => setEditingItem(kv)} color="primary">
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title={isGenerating ? t('users.generating') : t('users.generateRec')}>
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => {
                                                            handleGenerateRecommendations(kv.key).catch()
                                                        }}
                                                        disabled={isGenerating}
                                                    >
                                                        {isGenerating ? <CircularProgress size={24} /> : <AutoAwesomeIcon />}
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                            {isLoading ? t('common.loading') : t('common.noData')}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {recommendations && (
                        <Box mt={3} p={2} border={1} borderColor="divider" borderRadius={1}>
                            <Typography variant="h6" gutterBottom>
                                {t('keyValue.generatedRecs')}
                            </Typography>
                            <div dangerouslySetInnerHTML={{ __html: recommendations.replace(/\n/g, '<br>') }} />
                        </Box>
                    )}
                    {editingItem && (
                        <Dialog open fullWidth maxWidth="md">
                            <DialogTitle>{t('keyValue.editTitle', { key: editingItem.key })}</DialogTitle>
                            <DialogContent>
                                <TextField
                                    multiline
                                    fullWidth
                                    minRows={20}
                                    maxRows={30}
                                    value={editingItem.value}
                                    onChange={(e) => setEditingItem({...editingItem, value: e.target.value})}
                                    variant="outlined"
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setEditingItem(null)}>{t('common.cancel')}</Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={async () => {
                                        await handleUpdate(editingItem.key, editingItem.value);
                                        setEditingItem(null);
                                    }}
                                >
                                    {t('common.save')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                    <Box mt={2} display="flex" gap={1}>

                        {/*<TextField
                            label="Значение"
                            value={newValue}
                            onChange={(e) => setNewValue(e.target.value)}
                            size="small"
                        />*/}
                        <Button
                            variant="contained"
                            onClick={()=>setAddingItem(true)}
                            //disabled={!newKey.trim()}
                        >
                            {t('common.add')}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleApplyToAll}
                        >
                            {t('keyValue.applyAll')}
                        </Button>

                    </Box>

                    {addingItem && (
                        <Dialog open fullWidth maxWidth="md">
                            <DialogTitle>{t('keyValue.addTitle')}</DialogTitle>

                            <DialogContent>
                                <Box mt={2} display="flex" flexDirection="column" gap={1}>
                                    <TextField
                                        label={t('keyValue.newKey')}
                                        value={newKey}
                                        onChange={(e) => setNewKey(e.target.value)}
                                        size="small"
                                    />

                                    <TextField
                                        multiline
                                        fullWidth
                                        minRows={20}
                                        maxRows={30}
                                        value={newValue}
                                        onChange={(e) => setNewValue(e.target.value)}
                                        variant="outlined"
                                    />
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setAddingItem(false)}>{t('common.cancel')}</Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={async () => {
                                        await handleAdd();
                                        setAddingItem(false)
                                    }}
                                >
                                    {t('common.save')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </>
            )}
        </Box>
    );
};
const DashboardUsers = () => {


    const theme = createTheme();

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={getDayjsLocale()}>
            <ThemeProvider theme={theme}>

                <Box
                    sx={{
                        width:'95%'
                    }}
                >

                    <ReportsComponent />
                </Box>
            </ThemeProvider>
        </LocalizationProvider>

    );
};

export default DashboardUsers;
